import React from 'react'; 
import {Link} from 'react-router-dom' 
import UseLang from '../../../hooks/UseLang';

function AnalisisCaminosCadaPaisPrevew(props) { 
    return ( <> <UseLang es > 
        <div>
            <div> 
            <h1>Análisis de caminos desde cada país hacia el resto de la región
                    </h1>
                    <p>Autor: Elisa Peirano, I+D, LACNIC</p>

                    <p>Coordinación: Guillermo Cicileo, LACNIC</p>

                    <p>Área: I+D LACNIC</p>

                    <p>Fecha: 15/09/2025</p>
                    <Link className="buttons button_blue" to="/es/interconexion/analisis-de-caminos-desde-cada-pais-hacia-el-resto-de-la-region">Leer Reporte</Link>
                 
           
            </div> 
        </div>  </UseLang>
        <UseLang en> 
        <div>
            <div> 
            <h1>Analysis of Paths from Each Country to the Rest of the Region
            </h1>
            <p>Author: Elisa Peirano, I+D, LACNIC</p>
            <p>Coordination: Guillermo Cicileo, LACNIC</p>
            <p>Department: I+D LACNIC</p>
            <p>Edition: 15/09/2025</p>
            <Link className="buttons button_blue" to="/en/interconnection/analysis-of-paths-from-each-country-to-the-rest-of-the-region">Read Report</Link>
        </div> 
        </div>  
        </UseLang>
        </>
    );
}

export default AnalisisCaminosCadaPaisPrevew;

